var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex-container', {
    attrs: {
      "center": ""
    }
  }, [_c('v-card-container', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.left",
      value: (2),
      expression: "2",
      modifiers: {
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.right",
      value: (2),
      expression: "2",
      modifiers: {
        "right": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-row', {
    attrs: {
      "justify-content": "center"
    }
  }, [_c('v-col', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }]
  }, [(_vm.isRegister) ? _c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n                        Регистрация\n                    ")]) : _c('v-router-link', {
    attrs: {
      "size": "subheadling",
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("\n                        Регистрация\n                    ")])], 1), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }]
  }), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }]
  }, [(_vm.isLogin) ? _c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n                        Вход\n                    ")]) : _c('v-router-link', {
    attrs: {
      "size": "subheadling",
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("\n                        Вход\n                    ")])], 1)], 1)], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91ba5fae","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/MobileNaigation.vue
// module id = 824
// module chunks = 0